export default __webpack_public_path__ + "static/media/arrowRight.5ca13aac.svg";